import React, {Component, memo} from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ui from 'redux-ui';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import { setAppEnabled } from 'components/Apps/AppDetails/Redux/Actions';
import RedirectTo from 'components/Common/RedirectTo';

export const OPEN_GOOGLE_CAL_DIALOG = 'OPEN_GOOGLE_CAL_DIALOG'
export const CLOSE_GOOGLE_CAL_DIALOG = 'CLOSE_GOOGLE_CAL_DIALOG'

const styles = {
    image: {
        width: '100%',
        height: '100%'
    }
}

class GoogleCalConnectDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            imageLoaded: false
        }
    }

    handleClose() {
        this.props.handleClose()
    }

    handleConnectGoogleCalendar() {
        RedirectTo.googleAuth()
    }

    render() {
        const { classes } = this.props

        return (
            <Dialog
                open={this.props.ui.open}
                onClose={this.props.onClose}
            >
                <DialogTitle>
                    Connect to Google Calendar
                </DialogTitle>
                <div>
                    <img
                        className={classes.image}
                        src="https://s3-us-west-1.amazonaws.com/housecall-general/Assets/Integrations+page/google_cal_overview.png"/>
                </div>

                <DialogActions>
                    <Button
                        onClick={this.props.onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={() => {
                            this.handleConnectGoogleCalendar()
                            this.props.onClose()
                            this.props.enableApp()
                        }}
                    >
                        Connect
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default compose(
    ui({
        state: {
            open: false
        },
        reducer: (state, action) => {
            switch (action.type) {
                case OPEN_GOOGLE_CAL_DIALOG:
                    return state.set('open', true)
                case CLOSE_GOOGLE_CAL_DIALOG:
                    return state.set('open', false)
            }
            return state
        }
    }),
    connect(
        state => {
            return {}
        },
        dispatch => ({
            onClose: () => {
                dispatch({ type: CLOSE_GOOGLE_CAL_DIALOG })
            },
            enableApp: () => {
                dispatch(setAppEnabled())
            }
        })
    ),
    withStyles(styles),
    memo
)(GoogleCalConnectDialog)

